import { SurfaceTriangle } from "./surfaceTriangle";
import geospatialUtilities from "../../utilities/geospatialUtilities";

export const Surface = ({ surfaceDataObject }) => {
    const generatePositions = (triangleObject) => {
        let positionsArray = [];
        for (let i = 1; i <= 3; i++) {
            positionsArray.push([triangleObject[`y${ i }`], triangleObject[`x${ i }`], triangleObject[`z${ i }`]]);
        }
        geospatialUtilities.makePolygonSelfClosing(positionsArray)
        return positionsArray;
    }
    return <>{ surfaceDataObject.surfaceTriangles.map(triangle => <SurfaceTriangle positions={generatePositions(triangle)} />) }</>
    
}